import { PATHS } from '@/config/paths';

export const publicRoutes = [
  PATHS.auth.login,
  PATHS.auth.register,
  PATHS.auth.checkout,
  PATHS.auth.otp,
  PATHS.auth.resetPassword,
  PATHS.auth.resetNewPassword,
];

export const crossSharedRoutes = [PATHS.auth.checkout];
export const darkScreensRoutes = [PATHS.hubs.movies];

export const floatingInvestScreensRoutes = [
  PATHS.consolidator.comparator,
  PATHS.consolidator.index,
  PATHS.hubs.recommendation,
];

export const monetaryButtonHeaderScreensRoutes = [
  PATHS.consolidator.index,
  PATHS.financialPlanning.index,
  PATHS.financialPlanning.myGoals,
  PATHS.financialPlanning.immobilized,
  PATHS.financialPlanning.myWealth,
  PATHS.financialPlanning.financialControl,
];

export const routesDoNotSendVisit = [
  PATHS.auth.resetNewPassword,
  PATHS.home,
  PATHS.hubs.content,
  '/ativo/chart',
];

export const routesSHowDisclaimerEqiResearchHubs = [
  PATHS.hubs.recommendation,
  PATHS.hubs.research,
];
export const routesShowDisclaimerWebMobile = [
  ...publicRoutes,
  PATHS.custom.index,
];

export const canBePublicRoutes = [
  PATHS.event.index,
  PATHS.hubs.author,
  PATHS.hubs.content,
  PATHS.hubs.program,
  PATHS.hubs.research,
  PATHS.hubs.researchProgram,
  PATHS.news.index,
];
